import type { FC } from "react";
import { observer } from "@legendapp/state/react";
import { Button } from "primereact/button";
import { ThemeStore$, toggleTheme } from "@/stores/themeStore";
import { TEXT } from "@/constants/text";
import styles from "@/layouts/AppLayout/ThemeToggle.module.css";

const ThemeToggle: FC = observer(() => {
  const darkMode = ThemeStore$.darkMode.get();

  return (
    <Button
      icon={darkMode ? "pi pi-sun" : "pi pi-moon"}
      label={
        darkMode
          ? TEXT.appLayout.lightModeToggle
          : TEXT.appLayout.darkModeToggle
      }
      pt={{
        root: { className: styles.toggle },
        label: { className: styles.label },
      }}
      onClick={toggleTheme}
    />
  );
});

export default ThemeToggle;
